import { Text } from "@src/lib/ui-react";

export function SettingsItemTitle(data: {
  title?: string | JSX.Element;
  subtitle?: string | JSX.Element;
  hidden?: boolean | undefined;
}) {
  if (data.title && data.subtitle && !data.hidden) {
    return (
      <>
        <Text
          sx={{
            fontWeight: 300,
            marginBottom: "4px",
          }}
        >
          {data.title}
        </Text>
        <Text
          sx={{
            color: "rgba(0, 0, 0, 0.45)",
            fontSize: "14px",
          }}
        >
          {data.subtitle}
        </Text>
      </>
    );
  }
  if (!data.hidden) {
    return (
      <Text
        sx={{
          fontWeight: 500,
          marginBottom: "4px",
        }}
      >
        {data.title}
      </Text>
    );
  }

  return <></>;
}
